module.exports = __webpack_public_path__ + "img/knue_gallery13.4c40a02f.jpg";